import { DetailedHTMLProps, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SiderProps
  extends DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  children: ReactNode;
}

export default function Sider({ children, ...props }: SiderProps) {
  return (
    <nav
      {...props}
      className={twMerge("fl-p-8 fl-h-screen fl-bg-light", props.className)}
    >
      {children}
    </nav>
  );
}
